import React from 'react';
import PropTypes from 'prop-types';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';

const ForbiddenDialog = (props) => {
    return (
        <Dialog
            id="forbidden-dialog"
            disableBackdropClick
            disableEscapeKeyDown
            open={props.open}
        >
            <DialogTitle>
                Forbidden
            </DialogTitle>
            <DialogContent>
                <DialogContentText>
                    You are not allowed to access this resource.
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button
                    id="forbidden-dismiss-button"
                    onClick={props.onDismissClick}
                >
                    Ok
                </Button>
            </DialogActions>
        </Dialog>
    );
};

ForbiddenDialog.propTypes = {
    open: PropTypes.bool,
    onDismissClick: PropTypes.func,
};

ForbiddenDialog.defaultProps = {
    open: true,
    onDismissClick: () => {},
};

export default ForbiddenDialog;
